(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-banner"] && !Shopify.designMode) return;
  try {
    
  /**
   * Root cause of the dual-card ATC bug:
   * The cart drawer uses `dialog.showModal()` which, per the HTML spec,
   * makes the dialog modal and blocks ALL pointer events outside it —
   * including the second promo card's "Add to Cart" button.
   *
   * Fix: listen for CartAddEvent (= 'cart:update') originating from inside
   * a promo-banner section.  Before any bubble-phase handlers fire (we use
   * { capture: true }) we temporarily strip `auto-open` from the cart
   * drawer so it won't open.  A Promise microtask restores the attribute
   * AFTER all event handlers have run, keeping normal drawer behaviour for
   * every other ATC on the page.
   */
  document.addEventListener(
    'cart:update',
    function (event) {
      // Only intercept manual ATC submissions from product-form-component
      if (event.detail?.data?.source !== 'product-form-component') return;

      // Only act when the event originates inside a promo-banner section
      var promoSection =
        event.target && typeof event.target.closest === 'function'
          ? event.target.closest('.promo-banner-section')
          : null;
      if (!promoSection) return;

      var cartDrawer = document.querySelector('cart-drawer-component');
      if (!cartDrawer || !cartDrawer.hasAttribute('auto-open')) return;

      // Remove the attribute before bubble-phase handlers run,
      // so the cart drawer's #handleCartAdd sees no auto-open.
      cartDrawer.removeAttribute('auto-open');

      // Restore in a microtask — after ALL event handlers have executed —
      // so every other part of the page keeps its normal drawer behaviour.
      Promise.resolve().then(function () {
        cartDrawer.setAttribute('auto-open', '');
      });
    },
    { capture: true }
  );

  } catch(e) { console.error(e); }
})();
})();
